import { render } from "./ReviewSentRequestQuestion.vue?vue&type=template&id=ff574cb6&scoped=true&ts=true"
import script from "./ReviewSentRequestQuestion.vue?vue&type=script&lang=ts"
export * from "./ReviewSentRequestQuestion.vue?vue&type=script&lang=ts"

import "./ReviewSentRequestQuestion.vue?vue&type=style&index=0&id=ff574cb6&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff574cb6"]])

export default __exports__